/**
 * Timestamps are ISO strings on the wire but compared as numbers (SPEC rule 6): "2026-03-01"
 * and "2026-03-01T00:00:00+11:00" sort wrongly as strings.
 */
import type { IsoTime } from './types'

/** Milliseconds since the epoch; 0 for missing or unparseable, so such records lose ties. */
export function timeOf(iso: IsoTime | null | undefined): number {
  if (!iso) return 0
  // An offset-less date-time would parse as local time in a browser and as UTC on the worker;
  // read it as UTC everywhere so the two agree.
  const t = Date.parse(/T\d{2}:\d{2}(:\d{2}(\.\d+)?)?$/.test(iso) ? iso + 'Z' : iso)
  return Number.isFinite(t) ? t : 0
}

/**
 * The current time as ISO. The engine itself never calls this (it is pure); it is here so the
 * app, worker and pipeline mint timestamps one way.
 */
export function nowIso(): IsoTime {
  return new Date().toISOString()
}
